(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["girlow-discount"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('.gd__code');
  if(!b)return;
  var c=b.getAttribute('data-code');
  var done=function(){var m=b.querySelector('em');if(m){m.textContent='Copiato!';setTimeout(function(){m.textContent='Copia'},1800);}};
  if(navigator.clipboard){navigator.clipboard.writeText(c).then(done);}else{done();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["girlow-product-belt"] && !Shopify.designMode) return;
  try {
    
(function () {
  var M = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
  function fmt(d) { return d.getDate() + ' ' + M[d.getMonth()]; }
  function add(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
  function init() {
    document.querySelectorAll('.gbl').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var main = root.querySelector('#gbl-main');
      var thumbs = root.querySelectorAll('.gbl__thumb');
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (main) main.src = btn.dataset.src;
          thumbs.forEach(function (b) { b.classList.remove('is-on'); });
          btn.classList.add('is-on');
        });
      });
      var d = root.dataset;
      var ship = root.querySelector('[data-step=ship]');
      var del = root.querySelector('[data-step=del]');
      if (ship) ship.textContent = fmt(add(+d.shipMin)) + ' - ' + fmt(add(+d.shipMax));
      if (del) del.textContent = fmt(add(+d.delMin)) + ' - ' + fmt(add(+d.delMax));
      var qty = root.querySelector('.gbl__qty input');
      root.querySelectorAll('.gbl__qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.q, 10);
          qty.value = Math.min(10, Math.max(1, n));
        });
      });
      var data = root.querySelector('.gbl__variants');
      var variants = [];
      try { variants = JSON.parse(data.textContent); } catch (e) {}
      var idEl = root.querySelector('.gbl__id');
      var addBtn = root.querySelector('#gbl-add');
      var sBtn = root.querySelector('#gbl-sbtn');
      var stock = root.querySelector('#gbl-stock');
      var priceEl = root.querySelector('#gbl-price');
      var wasEl = root.querySelector('#gbl-was');
      var saveEl = root.querySelector('#gbl-save');
      var sPrice = root.querySelector('#gbl-sprice');
      var nf;
      try { nf = new Intl.NumberFormat('it-IT', { style: 'currency', currency: d.currency || 'EUR' }); } catch (e) { nf = null; }
      function money(c) { return nf ? nf.format(c / 100) : (c / 100).toFixed(2); }
      function onChange() {
        var vals = [];
        root.querySelectorAll('.gbl__opt').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          if (c) vals[+fs.dataset.pos] = c.value;
        });
        var m = variants.find(function (v) {
          return vals.every(function (val, i) { return val === undefined || v['option' + (i + 1)] === val; });
        });
        if (!m) return;
        if (idEl) idEl.value = m.id;
        if (priceEl) priceEl.textContent = money(m.price);
        if (sPrice) sPrice.textContent = money(m.price);
        var onSale = m.compare_at_price && m.compare_at_price > m.price;
        if (wasEl) { wasEl.hidden = !onSale; if (onSale) wasEl.textContent = money(m.compare_at_price); }
        if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = '-' + Math.floor((m.compare_at_price - m.price) * 100 / m.compare_at_price) + '%'; }
        if (stock) stock.hidden = !m.available;
        if (addBtn) { addBtn.disabled = !m.available; addBtn.textContent = m.available ? 'Aggiungi al carrello' : 'Esaurito'; }
        if (sBtn) sBtn.disabled = !m.available;
        if (m.featured_image && m.featured_image.src && main) {
          main.src = m.featured_image.src;
          thumbs.forEach(function (b) { b.classList.remove('is-on'); });
        }
        try { history.replaceState(null, '', '?variant=' + m.id); } catch (e) {}
      }
      root.querySelectorAll('.gbl__opt input').forEach(function (i) { i.addEventListener('change', onChange); });
      var sticky = root.querySelector('#gbl-sticky');
      var form = root.querySelector('.gbl__form');
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var e = es[0];
          sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
        }).observe(addBtn);
      }
      if (sBtn && form) sBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["girlow-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var M = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
  function fmt(d) { return d.getDate() + ' ' + M[d.getMonth()]; }
  function add(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
  function init() {
    document.querySelectorAll('.gx').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var main = root.querySelector('#gx-main');
      var thumbs = root.querySelectorAll('.gx__thumb');
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (main) main.src = btn.dataset.src;
          thumbs.forEach(function (b) { b.classList.remove('is-on'); });
          btn.classList.add('is-on');
        });
      });
      var copy = root.querySelector('.gx__copy');
      if (copy) copy.addEventListener('click', function () {
        var label = copy.querySelector('span');
        if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.code).catch(function () {});
        if (label) { label.textContent = 'Copiato'; setTimeout(function () { label.textContent = 'Copia'; }, 1800); }
      });
      var d = root.dataset;
      var ship = root.querySelector('[data-step=ship]');
      var del = root.querySelector('[data-step=del]');
      if (ship) ship.textContent = fmt(add(+d.shipMin)) + ' - ' + fmt(add(+d.shipMax));
      if (del) del.textContent = fmt(add(+d.delMin)) + ' - ' + fmt(add(+d.delMax));
      var data = root.querySelector('.gx__variants');
      var selects = root.querySelectorAll('.gx__select');
      if (data && selects.length) {
        var variants = JSON.parse(data.textContent);
        var idEl = root.querySelector('.gx__id');
        var btnEl = root.querySelector('.gx__btn');
        var stockEl = root.querySelector('.gx__stock');
        var priceEl = root.querySelector('#gx-price');
        var nf;
        try { nf = new Intl.NumberFormat('it-IT', { style: 'currency', currency: d.currency || 'EUR' }); } catch (e) { nf = null; }
        var onChange = function () {
          var vals = [];
          selects.forEach(function (s) { vals[+s.dataset.pos] = s.value; });
          var m = variants.find(function (v) {
            return vals.every(function (val, i) { return v['option' + (i + 1)] === val; });
          });
          if (!m) return;
          if (idEl) idEl.value = m.id;
          if (priceEl && nf) priceEl.textContent = nf.format(m.price / 100);
          if (stockEl) stockEl.hidden = !m.available;
          if (btnEl) { btnEl.disabled = !m.available; btnEl.textContent = m.available ? 'Aggiungi al carrello' : 'Esaurito'; }
          if (m.featured_image && m.featured_image.src && main) {
            main.src = m.featured_image.src;
            thumbs.forEach(function (b) { b.classList.remove('is-on'); });
          }
          try { history.replaceState(null, '', '?variant=' + m.id); } catch (e) {}
        };
        selects.forEach(function (s) { s.addEventListener('change', onChange); });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
